import teacherHolly from "@/assets/teacher-holly.jpg";
import teacherKristine from "@/assets/teacher-kristine.jpg";
import teacherSarah from "@/assets/teacher-sarah.jpg";
import teacherBrittani from "@/assets/teacher-brittani.jpg";
import teacherDestiny from "@/assets/teacher-destiny.jpg";
import teacherAmanda from "@/assets/teacher-amanda.jpg";
import teacherMeeka from "@/assets/teacher-meeka.jpg";
import teacherSarra from "@/assets/teacher-sarra.jpg";
import teacherSeth from "@/assets/teacher-seth.jpg";
import teacherSophia from "@/assets/sophia.png";
import teacherDeja from "@/assets/teacher-deja.jpg";
import teacherChais from "@/assets/teacher-chais.jpg";
import teacherSpencer from "@/assets/teacher-spencer.jpg";

export interface Teacher {
  id: string;
  name: string;
  title: string;
  bio: string;
  specialties: string[];
  image: string;
}

export const teachers: Teacher[] = [
  {
    id: "seth",
    name: "Pastor Seth",
    title: "Church Liaison — Grace Community Church",
    bio: "Pastor Seth serves at Grace Community Church in Boulder City, NV, and is the liaison for the Silver Sage Homeschool Hub program. He helps make our learning space possible by opening the church's doors to our community of homeschool families, supporting the Hub's mission with enthusiasm and care.",
    specialties: ["Community Partnership", "Program Liaison", "Youth Ministry"],
    image: teacherSeth,
  },
  {
    id: "holly",
    name: "Miss Holly",
    title: "Founder & Lead Educator",
    bio: "Holly homeschools three boys and put together the Silver Sage Homeschool Hub so her children would have a place to explore their interests and learn from other trusted adults. She is an event planner, wedding decorator, homeschool pro, and lover of the outdoors.",
    specialties: ["Project-Based Learning", "Event Coordination", "Community Building"],
    image: teacherHolly,
  },
  {
    id: "spencer",
    name: "Mr. Spencer",
    title: "Auto 101 — Beginner's Automotive",
    bio: "My name is Spencer Earl. I have been passionate about cars from a very early age and have studied vehicle systems in college. I enjoy working on and maintaining vehicles, especially classic cars, as a personal hobby. I like teaching practical, real-world skills and aim to help students feel confident and capable when it comes to basic car ownership and safety.",
    specialties: ["Automotive Basics", "Vehicle Safety", "Classic Cars"],
    image: teacherSpencer,
  },
  {
    id: "sarra",
    name: "Miss Sarra",
    title: "Biology, Ecology & Outdoor Adventure",
    bio: "Although her history is steeped in biology and stream ecology, Miss Sarra is currently captivated by her job as a guide on the Colorado River. She has worked for Desert Adventures for the past 7 years as a kayak guide and instructor of kayaking safety, CPR/AED, and Wilderness Medicine. Prior to that, she was a native fish biologist for the State of Utah and a stream ecology technician for the Oregon Department of Environmental Quality.",
    specialties: ["Biology", "Stream Ecology", "Kayaking", "Wilderness Medicine"],
    image: teacherSarra,
  },
  {
    id: "sophia",
    name: "Miss Sophia",
    title: "Spanish, LEGO Robotics & Theater",
    bio: "Miss Sophia brings creativity and enthusiasm to every class she teaches. From helping students explore the Spanish language to guiding young engineers through LEGO Robotics builds and inspiring future performers in Theater class, she makes learning an exciting, hands-on adventure. Her versatility and passion for education make her a favorite among students of all ages.",
    specialties: ["Spanish", "LEGO Robotics", "Theater"],
    image: teacherSophia,
  },
  {
    id: "brittani",
    name: "Miss Brittani",
    title: "Home Economics & Family Traditions",
    bio: "Brittani is a proud mother of four who has been managing a busy household for over twenty years. She's excited to share the knowledge and traditions in home economics that have been passed down through several generations of her family — carrying on that legacy and helping others build strong, nurturing homes.",
    specialties: ["Home Economics", "Cooking", "Baking", "Family Traditions"],
    image: teacherBrittani,
  },
  {
    id: "sarah",
    name: "Miss Nancy",
    title: "Nature & Animal Sciences",
    bio: "Nancy spent 14 years farming in Northern Nevada, running a Certified Naturally Grown 5-acre family farm with everything from nearly 400 free-range chickens to cows, rabbits, and year-round produce in a hoop house. She ran a successful CSA, sold farm-raised meat and produce to local chefs, offered poultry butchering classes, and gave farm tours that showed children and adults where their food comes from. Now she keeps hens and coturnix quail for eggs and meat and grows fruit and vegetables in raised beds — bringing all that hands-on farm wisdom to the Hub.",
    specialties: ["Animal Care", "Sustainable Farming", "Farm to Table", "Outdoor Education"],
    image: teacherSarah,
  },
  {
    id: "kristine",
    name: "Miss Kristine",
    title: "English, History & Language Arts",
    bio: "Kristine is a lifelong learner with a love of movies, books, and the magic of history — which she describes as a mini time machine to different places in time. She holds a BA in Christian Ministries, a Child Development Certificate, and a TEFL certification, and was both a Theater Arts and English major with a minor in History. Kristine has taught full time, substituted, and tutored for many years, including working at Warner Bros. Studio Daycare, teaching 1st and 2nd grade at a private school, and substituting across a public school district. Fun fact: she once wrote a biography of her great-uncle, a boxer from the 1920s!",
    specialties: ["English Grammar", "History", "Theater Arts", "Tutoring"],
    image: teacherKristine,
  },
  {
    id: "destiny",
    name: "Miss Destiny",
    title: "Reading, Baking & Creative Arts",
    bio: "Miss Destiny loves reading and baking, especially on a cloudy day with a cup of tea! She has been with her husband since she was a teenager and they have two beautiful girls. Some of their favorite things to do as a family is watch baseball and go on long walks. Her dream is to someday write a book and visit art from around the world!",
    specialties: ["Reading", "Baking", "Creative Arts"],
    image: teacherDestiny,
  },
  {
    id: "amanda",
    name: "Miss Amanda",
    title: "Science & Co-op Education",
    bio: "Miss Amanda has been homeschooling her daughter for almost three years and has taught science lessons for a multi-aged co-op. She brings curiosity and hands-on enthusiasm to every lesson, making science accessible and exciting for learners of all ages.",
    specialties: ["Science", "Homeschool Co-op", "Hands-On Learning"],
    image: teacherAmanda,
  },
  {
    id: "meeka",
    name: "Miss Meeka",
    title: "STEAM, Movement & Social-Emotional Learning",
    bio: "Miss Meeka is an experienced educator, curriculum designer, and educational consultant with nearly two decades of teaching experience across K–12 settings. She specializes in creating engaging, hands-on learning experiences that blend STEAM, movement, and social-emotional learning. Her approach focuses on building confidence, creativity, and critical thinking through play, collaboration, and real-world application — helping students develop a love for learning in a fun, supportive, and high-energy environment.",
    specialties: ["STEAM", "Movement", "Social-Emotional Learning", "Curriculum Design"],
    image: teacherMeeka,
  },
  {
    id: "deja",
    name: "Miss Deja",
    title: "Baking & Mommy & Me",
    bio: "Hello, my name is Deja! I've been baking for as long as I can remember. But I really got serious about baking in 2020 during Covid when we had nothing else to do — and I discovered it was really a passion of mine. I love sharing that passion with families and helping kids and parents create sweet memories (and treats!) together in the kitchen.",
    specialties: ["Baking", "Mommy & Me", "Kitchen Basics"],
    image: teacherDeja,
  },
  {
    id: "chais",
    name: "Miss Chais",
    title: "Home Baking & Kitchen Confidence",
    bio: "Chais Tobler is a passionate home baker who loves creating delicious, approachable treats for others to enjoy. With a focus on simple techniques and reliable results, Chais enjoys helping others feel confident in the kitchen. She is excited to share her knowledge, tips, and enthusiasm in a fun, welcoming baking class designed for all skill levels.",
    specialties: ["Baking", "Kitchen Basics", "Beginner Friendly"],
    image: teacherChais,
  },
];
